/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedUserRetrieveUpdateRequestDto } from '../../models/backend-patched-user-retrieve-update-request-dto';
import { BackendUserRetrieveUpdateDto } from '../../models/backend-user-retrieve-update-dto';

export interface AccountMePartialUpdate$FormData$Params {
  body?: BackendPatchedUserRetrieveUpdateRequestDto;
}

export function accountMePartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params?: AccountMePartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendUserRetrieveUpdateDto>> {
  const rb = new RequestBuilder(rootUrl, accountMePartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendUserRetrieveUpdateDto>;
    }),
  );
}

accountMePartialUpdate$FormData.PATH = '/api/account/me/';
